import Vue from 'vue'
import dayjs from 'dayjs'

const isProd = process.env.VUE_APP_SERVER_ENV === 'prod' || process.env.VUE_APP_SERVER_ENV === 'release'

/** ****************** API 错误上报 ********************/
/**
 * 上报ARMS
 * @param {String} url 接口地址
 * @param {String|Number} code 返回码
 * @param {String} msgString 额外参数
 */
const armsReport = (url, code, msgString) => {
  if (window.__bl && window.__bl.api) {
    window.__bl.api(
      url, // url
      false, // success
      0, // 接口耗时
      code, // code
      msgString, // 返回信息
      dayjs().format('YYYY-MM-DD HH:mm:ss'),
      '',
      ''
    )
  }
}

const statusMap = {
  403: '无权限访问该资源',
  404: '请求的接口不存在',
  400: '参数错误，请检查输入',
  500: '服务器内部错误，请稍后重试',
  503: '服务暂时不可用，请稍后重试',
  504: '服务器响应超时，请稍后重试',
}

/**
 * 接口报错处理
 * @description arms 中的请求状态码取的是 HTTP status code
 * @param {Object} err
 */
export const apiErrorARMSHandler = (err) => {
  try {
    const { request, response } = { ...err }
    if (!isProd) return
    // 有响应（HTTP 错误）
    if (response) {
      const { status } = response

      if (Object.keys(statusMap).includes(String(status))) {
        let msgString = '{}'
        // 非403, 404上传请求参数和响应参数
        if (![403, 404].includes(status)) {
          let reqData = null
          if (err.config && err.config.data) {
            try {
              reqData = JSON.parse(err.config.data)
            } catch (e) {
              reqData = err.config.data
            }
          }
          msgString = JSON.stringify({
            req: reqData,
            res: response.data,
          })
        }
        armsReport(request ? request.responseURL : err.config.url, status, msgString)
      }
    }

    /**
     * 无响应（网络错误）, 不上传请求体
     * - 例: 请求超时、无网络连接
     */
    if (!response) {
      armsReport(request ? request.responseURL : err.config ? err.config.url : '', err.status || 'NETWORK_ERR')
    }
  } catch (error) {
    console.log('apiErrorARMSHandler ERROR', error)
  }
}

/**
 * 接口响应报错处理
 * @description arms 中的请求状态码取的是后端响应中的 code (业务自定义的 code)
 * @param {Object} err
 */
export const apiResponseErrorARMSHandler = (err) => {
  try {
    const { request, data, status, config } = { ...err }
    if (!isProd) return

    if (data && data.message && data.message.includes('请求太频繁')) {
      let reqData = null
      if (config && config.data) {
        try {
          reqData = JSON.parse(config.data)
        } catch (e) {
          reqData = config.data
        }
      }
      const msgString = JSON.stringify({
        req: reqData,
        res: data,
      })
      armsReport(request ? request.responseURL : config ? config.url : '', data.code || status, msgString)
    }
  } catch (error) {
    console.log('apiResponseErrorARMSHandler ERROR', error)
  }
}

/** ****************** JS 错误上报 ********************/
const ERROR_MAP = [
  'ReferenceError', // 引用错误
  'TypeError', // 类型错误
  'SyntaxError', // 语法错误
  'RangeError', // 范围错误 (例: 执行死循环)
  'URIError', // URI错误, 执行URI方法(encodeURI、decodeURI)时的入参非法
]

export const jsErrorARMSHandler = () => {
  if (!isProd) return

  Vue.config.errorHandler = (err, vm, info) => {
    if (ERROR_MAP.includes(err.name)) {
      if (window.__bl && window.__bl.error) {
        window.__bl.error(`${err.message} [${dayjs().format('MM-DD HH:mm:ss')}][${err.name}][${info}]`)
      }
    }
    console.error(err)
  }

  // 捕获未处理的 Promise 异常 (如果在 main.js 已经有，这里只做 ARMS 上报)
  window.addEventListener('unhandledrejection', (event) => {
    try {
      const reason = event.reason
      if (reason instanceof Error && ERROR_MAP.includes(reason.name)) {
        if (window.__bl && window.__bl.error) {
          window.__bl.error(
            `[UnhandledRejection] ${reason.message} [${dayjs().format('MM-DD HH:mm:ss')}][${reason.name}]`
          )
        }
      }
    } catch {
      // 避免上报逻辑自身报错
    }
  })
}
